import { EntityBase } from './EntityBase';

import { Validator } from 'breeze-client';

/// <code-import> Place custom imports between <code-import> tags

/// </code-import>

export class TypeHazardCode extends EntityBase {

   /// <code> Place custom code between <code> tags
   
   /// </code>

   // Generated code. Do not place code below this line.
   typeHazardCodeId: string;
   hSCode: string;
   hazardStatement: string;
   signalWord: string;
   sortNo: number;
   pict: string;
   pictCode: string;
   rowVersion: number;
}

